import { IQuiz } from '../IQuiz'

export const ocpPatterns3: IQuiz = {
  name: 'ocp-patterns-3',
  question: 'В чём смысл шаблона «Стратегия»?',
  variants: [
    {
      text: 'Этот шаблон вызывает сложные цепочки методов и заменяет их одним названием',
      description: 'Этим занимается «Фасад»'
    },
    {
      text: 'Этот шаблон позволяет менять настройки, конфигурацию или алгоритм в зависимости от ситуации и требований'
    },
    {
      text: 'Этот шаблон контролирует процесс вызова методов другого модуля, изменяя их действие',
      description: 'Этим занимается «Прокси»'
    }
  ],
  meta: {
    correctAnswers: [1]
  }
}
